import MediaService from '../../services/MediaService'
import AxiosErrorHandler from '../../helpers/AxiosErrorHandler'
import router from '../../router'
import ProjectsService from '../../services/ProjectsService'
import PoiService from '../../services/PoiService'
import MenuItemsService from '../../services/MenuItemsService'
import MediaHelper from '../../helpers/MediaHelper'
import Enums from '../../helpers/Enums'
import MediaManagerService from '../../services/MediaManagerService'
export const namespaced = true

const initialState = {
  mediaContext: '',
  mediaContextGalleries: [],
  media: [],
  currentMediaPageNumber: 1,
  mediaPageSize: 20,
  mediaParentGalleries: {},
  galleries: [],
  selectedMediaItem: {},
  selectedMediaItemParentGalleries: [],
  selectedMediaItemOtherGalleries: [],
  selectedGallery: null,
  //selectedGalleryGalleries: [],
  //selectedGalleryMedia: [],
  mediaTypes: []
}

export const state = {
  mediaContext: '',
  mediaContextGalleries: [],
  media: [],
  currentMediaPageNumber: 1,
  mediaPageSize: 20,
  mediaParentGalleries: {},
  galleries: [],
  selectedMediaItem: {},
  selectedMediaItemParentGalleries: [],
  selectedMediaItemOtherGalleries: [],
  selectedGallery: null,
  //selectedGalleryGalleries: [],
  //selectedGalleryMedia: [],
  mediaTypes: []
}

export const mutations = {
  SET_MEDIA_CONTEXT(state, rec) {
    if (rec === 'project' || rec === 'poi' || rec === 'menu_item')
      state.mediaContext = rec
  },
  SET_MEDIA(state, recs) {
    state.media = recs
  },
  REMOVE_MEDIA_ITEM(state, mediaIds) {
    state.media = state.media.filter(m => !mediaIds.includes(m.id))
  },
  ADD_MEDIA(state, recs) {
    state.media = state.media.map(m => recs.find(r => r.id === m.id) || m) //update existing
    // add new recs
    recs.map(r => {
      if (!state.media.find(m => r.id === m.id)) {
        state.media.push(r)
      }
    })
  },
  SET_CURRENT_PAGE_NUMBER(state, data) {
    state.currentMediaPageNumber = data
  },
  // SET_CONTEXT_AVAILABLE_GALLERIES(state, recs) {
  //   state.mediaContextGalleries = []
  //   recs.forEach(m => {
  //     if (m.mediaTypeId === Enums.MediaType.media_gallery) {
  //       state.mediaContextGalleries.push(m)
  //     }
  //   })
  // },
  SET_SELECTED_MEDIA_ITEM(state, rec) {
    state.selectedMediaItem = rec
  },
  // SET_SELECTED_MEDIA_ITEM_PARENT_GALLERIES(state, recs) {
  //   state.selectedMediaItemParentGalleries = recs
  //   state.selectedMediaItemOtherGalleries = MediaHelper.getAvailableGalleries(
  //     state.galleries,
  //     state.selectedMediaItemParentGalleries
  //   )
  // },
  // SET_SELECTED_GALLERY(state, rec) {
  //   state.selectedGallery = rec
  // },
  // SET_SELECTED_GALLERY_MEDIA(state, recs) {
  //   state.selectedGalleryMedia = MediaHelper.getMediaWithoutGalleries(recs)
  //   state.selectedGalleryGalleries = MediaHelper.getGalleries(recs)
  // },
  SET_MEDIA_TYPES(state, recs) {
    state.mediaTypes = recs
  },
  // ADD_MEDIA_PARENT_GALLERIES(state, data) {
  //   state.mediaParentGalleries = {}
  //   for (let i = 0, len = state.media.length; i < len; i++) {
  //     if (state.media[i].id === data.mediaId) {
  //       state.media[i].galleries = data.galleries
  //       state.mediaParentGalleries[data.mediaId] = data.galleries
  //       break
  //     }
  //   }
  // },
  RESET_STORE(state) {
    Object.assign(state, initialState)
  },
  RESET_PAGING(state) {
    state.currentMediaPageNumber = initialState.currentMediaPageNumber
    state.mediaPageSize = initialState.mediaPageSize
  }
}

export const actions = {
  setMediaContext: function(context, value) {
    context.commit('SET_MEDIA_CONTEXT', value)
    //await context.dispatch('fetchMedia')
  },

  fetchMedia: async function(context, value) {
    let res
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    value = Object.assign({}, value, {
      pageNumber: context.state.currentMediaPageNumber,
      pageSize: context.state.mediaPageSize
    })

    switch (state.mediaContext) {
      case 'project':
        res = await ProjectsService.getProjectMedia(
          context.rootGetters['ProjectStore/getSelectedProjectId'],
          value
        )
        break
      case 'poi':
        res = await PoiService.getMediaForPoi(
          context.rootGetters['PoiStore/getSelectedPoiId'],
          value
        )

        //context.commit('SET_CONTEXT_AVAILABLE_GALLERIES', res.data)

        // if (state.selectedGallery !== null) {
        //   res = await MediaService.getGalleryContent(state.selectedGallery.id)
        // }
        break
      case 'menu_item':
        res = await MenuItemsService.getMediaForMenuItem(
          context.rootGetters['MenuItemsStore/getSelectedMenuItemId']
        )

        break
      default:
        break
    }

    if (res.data.length === context.state.mediaPageSize) {
      context.commit(
        'SET_CURRENT_PAGE_NUMBER',
        context.state.currentMediaPageNumber + 1
      )
    }

    context.commit('ADD_MEDIA', res.data)

    // if (res.data.length === context.state.mediaPageSize) {
    //   context.commit('ADD_MEDIA', res.data)
    //   context.commit(
    //     'SET_CURRENT_PAGE_NUMBER',
    //     context.state.currentMediaPageNumber + 1
    //   )
    // } else if (
    //   res.data.length > 0 &&
    //   res.data.length < context.state.mediaPageSize
    // ) {
    //   let mediaIds = context.state.media.map(m => m.id)
    //   let mediaToAdd = res.data.filter(m => {
    //     return !mediaIds.includes(m.id)
    //   })
    //   if (mediaToAdd.length > 0) {
    //     context.commit('ADD_MEDIA', mediaToAdd)
    //   } else {
    //     console.warn('End of list!')
    //   }
    // }

    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
    return res
  },

  refreshMedia: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    try {
      let mediaIds = value,
        res
      if (!Array.isArray(value)) {
        mediaIds = [mediaIds]
      }
      value = Object.assign({}, value, {
        mediaId: mediaIds
      })
      switch (state.mediaContext) {
        case 'project':
          res = await ProjectsService.getProjectMedia(
            context.rootGetters['ProjectStore/getSelectedProjectId'],
            value
          )
          break
        case 'poi':
          res = await PoiService.getMediaForPoi(
            context.rootGetters['PoiStore/getSelectedPoiId'],
            value
          )

          //context.commit('SET_CONTEXT_AVAILABLE_GALLERIES', res.data)

          // if (state.selectedGallery !== null) {
          //   res = await MediaService.getGalleryContent(state.selectedGallery.id)
          // }
          break
        case 'menu_item':
          res = await MenuItemsService.getMediaForMenuItem(
            context.rootGetters['MenuItemsStore/getSelectedMenuItemId']
          )

          break
        default:
          break
      }
      context.commit('ADD_MEDIA', res.data)
    } catch (e) {
      AxiosErrorHandler.handler(e, context, router)
    }

    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
  },

  setSelectedMediaItem: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    let m = await MediaService.getMediaById(value).catch(e => {
      //context.commit('SET_SELECTED_MEDIA_ITEM', null)
      context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      AxiosErrorHandler.handler(e, context, router)
    })
    context.commit('SET_SELECTED_MEDIA_ITEM', m.data)
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
  },
  // getMediaItemsParentGalleries: async function(context, value) {
  //   for (let i = 0, len = state.media.length; i < len; i++) {
  //     let g = await MediaService.getParentGalleries(state.media[i].id)
  //     context.commit('ADD_MEDIA_PARENT_GALLERIES', {
  //       mediaId: state.media[i].id,
  //       galleries: g.data
  //     })
  //   }
  // },
  getSelectedMediaItemParentGalleries(context, value) {
    if (state.selectedMediaItem.id)
      MediaService.getParentGalleries(state.selectedMediaItem.id).then(
        r => {
          context.commit('SET_SELECTED_MEDIA_ITEM_PARENT_GALLERIES', r.data)
          context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        },
        e => {
          context.commit('SET_SELECTED_MEDIA_ITEM_PARENT_GALLERIES', null)
          context.commit('SET_LOADING_STATUS', 'idle', { root: true })
          AxiosErrorHandler.handler(e, context, router)
        }
      )
  },

  createMedia: async function(context, value) {
    let res
    switch (state.mediaContext) {
      case 'project':
        {
          res = await ProjectsService.createProjectMedia(
            context.rootGetters['ProjectStore/getSelectedProjectId'],
            value
          ).catch(e => {
            AxiosErrorHandler.handler(e, context, router)
          })
        }
        break
      case 'poi':
        {
          res = await PoiService.createMediaForPoi(
            context.rootGetters['PoiStore/getSelectedPoiId'],
            value
          ).catch(e => {
            AxiosErrorHandler.handler(e, context, router)
          })
        }
        break
      case 'menu_item':
        {
          res = await MenuItemsService.createMediaForMenuItem(
            context.rootGetters['MenuItemsStore/getSelectedMenuItemId'],
            value
          ).catch(e => {
            AxiosErrorHandler.handler(e, context, router)
          })
        }
        break
      default:
        break
    }
    return res
  },
  updateMedia: async function(context, value) {
    let res
    switch (state.mediaContext) {
      case 'project':
        {
          res = await ProjectsService.updateProjectMedia(
            context.rootGetters['ProjectStore/getSelectedProjectId'],
            value
          ).catch(e => {
            AxiosErrorHandler.handler(e, context, router)
          })
        }
        break
      case 'poi':
        {
          res = await PoiService.updateMediaForPoi(
            context.rootGetters['PoiStore/getSelectedPoiId'],
            value
          ).catch(e => {
            AxiosErrorHandler.handler(e, context, router)
          })
        }
        break
      case 'menu_item':
        {
          res = await MenuItemsService.updateMediaForMenuItem(
            context.rootGetters['MenuItemsStore/getSelectedMenuItemId'],
            value
          ).catch(e => {
            AxiosErrorHandler.handler(e, context, router)
          })
        }
        break
      default:
        break
    }
    context.dispatch('fetchMedia')
    return res
  },
  deleteMedia: async function(context, value) {
    let res
    try {
      switch (state.mediaContext) {
        case 'project':
          {
            res = await ProjectsService.deleteProjectMedia(
              context.rootGetters['ProjectStore/getSelectedProjectId'],
              value
            )
            context.commit('REMOVE_MEDIA_ITEM', value)
          }
          break
        case 'poi':
          {
            res = await PoiService.deleteMediaForPoi(
              context.rootGetters['PoiStore/getSelectedPoiId'],
              value
            )
            context.commit('REMOVE_MEDIA_ITEM', value)
          }
          break
        case 'menu_item':
          {
            res = await MenuItemsService.deleteMediaForMenuItem(
              context.rootGetters['MenuItemsStore/getSelectedMenuItemId'],
              value
            )
            context.commit('REMOVE_MEDIA_ITEM', value)
          }
          break
        default:
          break
      }
    } catch (e) {
      AxiosErrorHandler.handler(e, context, router)
    }

    await context.commit('SET_SELECTED_MEDIA_ITEM', null)
    // context.dispatch('fetchMedia')
  },

  uploadFiles: async function(context, value) {
    return await MediaService.upload(
      value.files,
      context.rootGetters['ProjectStore/getSelectedProjectId']
    ).catch(e => {
      AxiosErrorHandler.handler(e, context, router)
    })
  },
  downloadFile: function(context, value) {
    return MediaService.getThumbnail(value)
  },
  addToGallery(context, value) {
    MediaService.addToGallery(value.galleryId, value.mediaIds)
      .then(res => {
        context.dispatch('getSelectedMediaItemParentGalleries')
      })
      .catch(e => {
        AxiosErrorHandler.handler(e, context, router)
      })
  },
  addToMultipleGalleries(context, value) {
    MediaService.addToMultipleGalleries(value.mediaId, value.galleryIds)
      .then(res => {
        context.dispatch('getSelectedMediaItemParentGalleries')
      })
      .catch(e => {
        AxiosErrorHandler.handler(e, context, router)
      })
  },
  removeFromGallery(context, value) {
    MediaService.removeFromGallery(value.galleryId, value.mediaId)
      .then(res => {
        context.dispatch('getSelectedMediaItemParentGalleries')
      })
      .catch(e => {
        AxiosErrorHandler.handler(e, context, router)
      })
  },
  setSelectedGallery: async function(context, value) {
    // context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    // let media = await MediaService.getMediaById(value).catch(e => {
    //   context.commit('SET_SELECTED_GALLERY', null)
    //   context.commit('SET_LOADING_STATUS', 'idle', { root: true })
    //   AxiosErrorHandler.handler(e, context, router)
    // })
    // let galleryContent = await MediaService.getGalleryContent(value).catch(
    //   e => {
    //     //context.commit('SET_SELECTED_GALLERY_MEDIA', null)
    //     context.commit('SET_LOADING_STATUS', 'idle', { root: true })
    //     AxiosErrorHandler.handler(e, context, router)
    //   }
    // )
    // context.commit('SET_SELECTED_GALLERY', media.data)
    // context.commit('SET_MEDIA', galleryContent.data)
    // context.commit('SET_LOADING_STATUS', 'idle', { root: true })
  },
  unsetSelectedGallery: function(context) {
    context.commit('SET_SELECTED_GALLERY', null)
    //context.commit('SET_SELECTED_GALLERY_MEDIA', null)
  },
  getGalleryContents: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })

    let recs = await MediaService.getGalleryContent(value).catch(e => {
      //context.commit('SET_SELECTED_GALLERY_MEDIA', null)
      context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      AxiosErrorHandler.handler(e, context, router)
    })
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
    return recs.data
  },
  fetchMediaTypes: async function(context, value) {
    // context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    // let r = await MediaService.getMediaTypes().catch(e => {
    //   context.commit('SET_MEDIA_TYPES', null)
    //   context.commit('SET_LOADING_STATUS', 'idle', { root: true })
    //   AxiosErrorHandler.handler(e, context, router)
    // })
    // context.commit('SET_MEDIA_TYPES', r.data)
    // context.commit('SET_LOADING_STATUS', 'idle', { root: true })
    return MediaService.getMediaTypes(value).then(
      r => {
        context.commit('SET_MEDIA_TYPES', r.data)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_MEDIA_TYPES', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },

  getFile: function(context, value) {
    let targetContext = 'media'
    let parentId = ''
    let queryParams = ''
    //check if dzi file
    if (value.path.toLowerCase().indexOf('.dzi') !== -1) {
      queryParams = '?type=thumbnail'
    }
    //console.log('MEDIA CONTEXT ', state.mediaContext)
    // console.log(
    //   'project id ',
    //   context.rootGetters['ProjectStore/getSelectedProjectId']
    // )
    switch (state.mediaContext) {
      case 'project':
        parentId = context.rootGetters['ProjectStore/getSelectedProjectId']
        targetContext = 'projects'
        break
      case 'poi':
        parentId = context.rootGetters['PoiStore/getSelectedPoiId']
        targetContext = 'pois'
        break
      case 'menu_item':
        parentId = context.rootGetters['MenuItemsStore/getSelectedMenuItemId']
        targetContext = 'menu-items'
        break
      default:
        parentId = context.rootGetters['ProjectStore/getSelectedProjectId']
        targetContext = 'projects'
        break
    }
    return MediaService.getMediaFile(
      `${targetContext}/${parentId}/media-content/${
        value.id
      }/file${queryParams}`
    )
  },
  resetStore: async function(context) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    context.commit('RESET_STORE')
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
  },
  resetMedia: async function(context) {
    context.commit('SET_MEDIA', [])
  },
  resetPaging: function(context) {
    context.commit('RESET_PAGING')
  }
}

export const getters = {}
